import React from 'react';
import ScheduleTableRows from './rows';

const ScheduleTable = (props) => (
  <table className="schedule-table">
    <thead>
      <tr>
        <th className="show-for-sr">{props.Translations.day}</th>
        <td className="show-for-sr">{props.Translations.openinghours}</td>
        <td className="show-for-sr">{props.Translations.comments}</td>
      </tr>
    </thead>
    <tbody className="schedule-table__body">
      {props.Schedule &&
        props.Schedule?.map((item, index) => (
          <ScheduleTableRows key={index} Schedule={item} />
        ))}
    </tbody>
  </table>
);

export default ScheduleTable;
